import { useFormContext } from 'react-hook-form'
import { useEffect } from 'react'
import { CreatePolicyInput } from '../../types/SettingsType.ts'

interface IPolicyDetailsProps {
  setIsNextEnabled: (enabled: boolean) => void
  policyDetails: CreatePolicyInput | undefined
  onDetailsChange?: (details: CreatePolicyInput) => void
}

function PolicyDetails(props: IPolicyDetailsProps) {
  const { setIsNextEnabled, policyDetails, onDetailsChange } = props
  const { register, formState, watch, reset } = useFormContext()
  const nameValue = watch('name')
  const descriptionValue = watch('description')

  useEffect(() => {
    setIsNextEnabled(!!nameValue && formState.isValid)
  }, [nameValue, formState.isValid])

  useEffect(() => {
    if (!policyDetails) return

    const current = {
      name: nameValue,
      description: descriptionValue,
    }

    const incoming = {
      name: policyDetails.name || '',
      description: policyDetails.description || '',
    }

    if (current.name !== incoming.name || current.description !== incoming.description) {
      reset(incoming)
    }
  }, [policyDetails, reset])

  useEffect(() => {
    setIsNextEnabled(!!nameValue && formState.isValid)

    if (onDetailsChange) {
      onDetailsChange({
        name: nameValue || '',
        description: descriptionValue || '',
      })
    }
  }, [nameValue, descriptionValue, formState.isValid])

  return (
    <>
      <div className="flex flex-col gap-4">
        <div className="w-[800px] p-4 bg-neutral-2 rounded-lg outline outline-1 outline-mainBorder inline-flex flex-col justify-end items-start overflow-hidden mx-auto">
          <div className="justify-center text-mainText font-semibold">Details</div>
          <div className="justify-center text-mainText text-sm font-normal">
            Give the policy a name and description to clearly define its purpose and scope
          </div>
          <label className="text-textTertiary text-sm w-full mb-1 mt-4">Policy Name</label>
          <input
            {...register('name', { required: true })}
            placeholder="Enter name"
            className={`not-form-styled placeholder-secondaryText focus:border-borderPurple focus:border-1 hover:border hover:border-borderPurple hover:dark:border-borderPurple focus:ring-1 focus:ring-borderPurple bg-inputBackground border border-mainBorder rounded`}
            maxLength={60}
            type="text"
          />

          <div className="mt-2 w-full">
            <label className="text-textTertiary text-sm w-full">Policy Description (optional)</label>
            <textarea
              {...register('description')}
              placeholder="Enter helpful details about the policy..."
              maxLength={240}
              rows={4}
              className="w-full rounded border border-mainBorder p-2 text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white mt-1"
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default PolicyDetails
